/**
 * Alert Component - Template
 * ============================
 * `ecAlertTitle`/`ecAlertText`/`ecAlertActions` son marcadores de slot
 * nombrado (como `<ec-label>` en los form controls) — no tienen componente
 * ni controller propio; el padre los captura vía `transclude` y aplica sus
 * propias clases (tema, tipografía, gap), así el layout no se pierde sea
 * cual sea el contenido que el consumidor transcluya.
 */

export const ALERT_TEMPLATE: string = `
<div class="ec-alert" ng-class="$ctrl.getContainerClasses()">
  <div class="ec-alert-row" ng-class="$ctrl.getRowClasses()">
    <span
      ng-if="$ctrl.showIcon"
      ng-class="$ctrl.getIconClasses()"
      ng-bind-html="$ctrl.trustedIcon"
      aria-hidden="true"
    ></span>

    <div ng-class="$ctrl.getContentClasses()">
      <div ng-class="$ctrl.getTextBlockClasses()">
        <p ng-if="$ctrl.showTitle && ($ctrl.title || $ctrl.hasTitleSlot)" ng-class="$ctrl.getTitleClasses()">
          <span ng-if="$ctrl.hasTitleSlot" ng-transclude="titleSlot"></span>
          <span ng-if="!$ctrl.hasTitleSlot">{{ $ctrl.title }}</span>
        </p>
        <p ng-if="$ctrl.description || $ctrl.hasTextSlot" ng-class="$ctrl.getTextClasses()">
          <span ng-if="$ctrl.hasTextSlot" ng-transclude="textSlot"></span>
          <span ng-if="!$ctrl.hasTextSlot">{{ $ctrl.description }}</span>
        </p>
      </div>
      <div ng-if="$ctrl.hasActionsSlot" ng-class="$ctrl.getActionsClasses()" ng-transclude="actionsSlot"></div>
    </div>

    <button
      ng-if="$ctrl.showDismiss"
      type="button"
      ng-class="$ctrl.getDismissClasses()"
      ng-click="$ctrl.handleDismiss($event)"
      ng-bind-html="$ctrl.trustedDismissIcon"
      aria-label="Cerrar"
    ></button>
  </div>
</div>
`;

export default ALERT_TEMPLATE;
